import { render, staticRenderFns } from "./IBooking.vue?vue&type=template&id=408aa378&scoped=true"
import script from "./IBooking.vue?vue&type=script&lang=js"
export * from "./IBooking.vue?vue&type=script&lang=js"
import style0 from "./IBooking.vue?vue&type=style&index=0&id=408aa378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408aa378",
  null
  
)

export default component.exports